<template>
  <div class="filter-container">
    <b-field horizontal :label="`${this.label}:`">
    <AutoCompleteMultiple :options="this.options"
      :value="query.map(q => q.value)" @input="(v) => $emit('input', getResult(v))"/>
    </b-field>
  </div>
</template>

<script>
import AutoCompleteMultiple from '@/components/AutoCompleteMultiple';

export default {
  components: {
    AutoCompleteMultiple,
  },
  props: {
    options: Array,
    queryKey: String,
    label: String,
    query: { type: Array, default: () => [] },
  },
  computed: {
    fromValue() {
      const fromQuery = this.query.find(q => q.queryKey === this.fromKeyGetter(this.queryKey));
      return fromQuery && fromQuery.value;
    },
    toValue() {
      const toQuery = this.query.find(q => q.queryKey === this.toKeyGetter(this.queryKey));
      return toQuery && toQuery.value;
    },
  },
  methods: {
    getResult(values) {
      return values.map(v => ({
        label: `${this.label}: ${v}`,
        value: v,
        queryKey: this.queryKey,
      }));
    },
  },
};
</script>


<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 12rem;
}
</style>
